(function($) {
	'use strict';
	$.fn.Login__GuestLogin = function() {
		this.each(function() {


			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Get options
				var guest_login_overlay = $('#guest-login-form').html(),
					$overlay, $form;

				// Parse it
				Mustache.parse( guest_login_overlay );
				var output = Mustache.render( guest_login_overlay );

				// Add it to dom and fade it in
				$.Body.append( output );

				// Redefine $overlay as jQuery Dom Obj
				$overlay = $('body > #overlay-white');
				$form = $overlay.find('form');

				// Ensure Async
				setTimeout( function() {

					// Fade it in
					$.Body.addClass('overlay-white-on');

					// Select the text
					$overlay.find('input[type="text"]').first().select();

					// Listen for submit
					$form.off('submit.guest-signin').on('submit.guest-signin', function(e){
						e.preventDefault();

						var email = $('#email').val();
						if( $.Globals.isEmail( email ) ) {

							var redirect = $form.data('redirecturl');

							// Store email address and get our user id
							$.ajax({
								url: Front.api_url + "?action=scspaces_set_public_user&email=" + email + "&type=json",
								dataType: 'json',
								success: function( response ) {

									if( response.success ){

										// Send info to Google Analytics
										$.Globals.track_page();
										$.Globals.track_event( 'Shared Login' );

										// Finally, redirect to the URL
										window.location = redirect;

									} else if( response.data.code === '818' ) {

										// Code 818 is the user is a steelcase employee
										console.log('User is a steelcase employee... redirecting to login.');
										window.location = $('.button.employee-login').attr('href');

									} else {

										console.warn( 'API is not setting user ID correctly.');

									}

								},
								cache: false,
								timeout: 3000 // 3 second timeout
							});

						} else {
							$('#enter-email .error').show();
						}

					});


					// Add global close overlay listener
					$.Globals.listenForGlobalCloseOverlay();

				}, 10 );

			});




		});
		return this;
	};
}(jQuery));
